import React from 'react';
import VisitorMap from '../../components/VisitorMap/VisitorMap';
import VisitorChart from '../../components/VisitorChart/VisitorChart';
import RegisterClickStats from '../../components/RegisterClickStats/RegisterClickStats';
import './AnalyticsOverview.scss';

const AnalyticsOverview = () => {
  return (
    <div className="analytics-overview">
      <div className="overview-header">
        <h2>Analytics Overview</h2>
        <p>Comprehensive view of your visitor analytics including location data and statistics.</p>
      </div>
      
      <div className="overview-content">
        <RegisterClickStats />
        <VisitorChart />
        <VisitorMap />
      </div>
    </div>
  );
};

export default AnalyticsOverview;

